import { DividendList, GetTradesParams, DividendFilter } from "../types";
import { User } from "../../../auth/types";
import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

const getDividendsWebApi = (
  user: User,
  page?: number,
  itemsPerPage?: number,
  filter?: DividendFilter,
) => {
  const params: GetTradesParams = {
    userid: user.userId,
    secid: filter?.security?.securityId,
    numofrows: itemsPerPage,
    fromrow: page && itemsPerPage ? page * itemsPerPage : undefined,
    datefrom: getParamsDateString(filter?.datefrom),
    dateto: getParamsDateString(filter?.dateto),
  };

  return webApiWithResponse<DividendList[]>({
    method: "GET",
    url: "reporting/getdividendlist",
    params,
  });
};

export default getDividendsWebApi;
